import { defineComponent as _defineComponent } from 'vue'
import { Address } from '@/models/Address';
import { EventOrganizer } from '@/models/EventOrganizer';
import { Location } from '@/models/Location';
import TypIcon from './TypIcon.vue';
import LegalTypeIcon from './LegalTypeIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressIconBar',
  props: {
    item: null,
    hideStatusIcon: { type: Boolean },
    size: null
  },
  setup(__props: any) {

const props = __props as {
    item: Address | EventOrganizer | Location | null;
    hideStatusIcon?: boolean;
    size?: number | string;
};



return { __sfc: true,props, TypIcon, LegalTypeIcon }
}

})